import { LIGHT } from './types';

export default {
  title: LIGHT,
  colors: {
    charts: {
      backgroundChartColor: '#FFF',
      title: '#610082',
      label: {
        text: '#6C6C6C',
        line: '#6C6C6C',
      }, // default config
      legend: {
        color: '#6C6C6C',
        pagination: {
          buttons: {
            color: '#333333',
          },
          text: {
            color: '#333333',
          },
        },
      },
      cardThemes: {
        neutral: [
          '#12004A', '#18106A', '#1F208A', '#2531AA', '#2C41CA', 
          '#3251EA', '#3161EC', '#3071EE', '#2E80F0', '#2D90F2', 
          '#2CA0F4', '#52B1F6', '#78C2F8', '#9ED4FA'
        ],
      },
      colors: [
        '#5A6FC0', '#9ECA7F', '#F2CA6B', '#DE6E6A', '#85BEDB',
        '#59A076', '#EC8A5D', '#9263AF', '#DC82C8', '#47599C',
        '#6F9D4E', '#D0A132', '#FF9896', '#3D83A6', '#3D7F58',
        '#AD5F3C', '#6D4586', '#BD60A9', '#354A78', '#617F4D',
        '#AD7B02', '#AA6976', '#196084', '#2E6243', '#8E4625',
        '#53256F', '#9A4086'],
      axis: {
        x: {
          label: '#6C6C6C',
          line: '#6C6C6C',
        },
        y: {
          label: '#6C6C6C',
          line: '#6C6C6C',
        },
      },
      radar: {
        radiusAxis: {
          label: '#6C6C6C',
          line: '#6C6C6C',
          splitLine: '#F5F6FA',
        },
      },
      correlation: {
        zoom: {
          buttons: '#610082',
          disabled: '#6C6C6C',
          divider: '#f5f6fa',
        },
      },
      simulation: {
        gradientTargetColor: 'rgba(255, 255, 255, 0)',
      },
      highlitedItemBorderType: 'dashed',
      highlitedItemBorderColor: '#6C6C6C',
      highlitedItemBorderWidth: 2,
    },
    primary: '#610082',
    secondary: '#00BEC1',
    highLight: '#24E5EA',
    statusError: '#EB5757',
    constrat: '#610082',
    brand: '#610082',
    component: '#F5F6FA',
    details: '#F5F6FA',
    text: {
      default: '#6C6C6C',
      placeholder: '#6C6C6C',
    },
    diviserColor: '#EfEfEf',
    diviserSmoothColor: '#e6e6e7',
    backgroundColorPage: '#F5F6FA',
    backgroundColorcomponent: '#FFFFFF',
    titleButtonSeletorHead: '#610082',
    cartTitleColor: '#610082',
    cardTypeColor: '#610082',
    inputSearchColor: '#F5F6FA',
    groupInputsColor: '#F5F6FA',
    groupInputsSeletorWrapperColor: '#FFFFFF',
    cardSeletorHeadColor: '#F5F6FA',
    actionButtonsColor: '#610082',
    avataBackgroundColor: '#610082',
    avataTextColor: '#FFF',
    avataTextColorExit: '#610082',
    avataBorderColor: '#610082',
    avataShadowColor: 'rgba(0, 0, 0, 0.05)',
    avataDiviserColor: 'rgba(255, 255, 255, 0.1);',
    cardSettingsTitleColor: '#610082',
    cardSettingsTextColor: '#610082',
    cardSettingsBackgroundcolor: '#FFFFFF',
    cardSettingsSeletorBodyBorderColor: '#610082',
    cardSettingsSeletorBackgroundColor: 'rgb(245, 246, 250)',
    exportingPopupTitleColor: '#610082',
    exportingPopupTextColor: '#610082',
    exportingPopupBtnDisabled: '#6C6C6C',
    exportingPopupOkBtn: '#610082',
    exportingPopupBackgroundcolor: '#FFFFFF',
    exportingPopupSeletorBodyBorderColor: '#610082',
    exportingPopupSeletorBackgroundColor: 'rgb(245, 246, 250)',
    previewComponentLabelColor: '#610082',
    previewComponentInputColor: '#00BEC1',
    previewComponentBackgroundColor: '#FFFFFF',
    previewComponentHeaderBackgroundColor: '#610082',
    previewComponentDivisorColor: '#F5F6FA',
    seletorSimpleSeletorBodyColor: '#FFFFFF',
    seletorSearchBackgroundcolor: '#FFFFFF',
    seletorBodyBorderColor: '#F5F6FA',
    chartEmptyColor: '#E1E2E5',
    chartEmptyTopRowColor: '#610082',
    chartEmptyHeaderTextColor: '#610082',
    chartEmptyHelperTextColor: '#4C555C',
    chartEmptyTextRowColor: '#610082',
    UploadSurveyTitleColor: '#610082',
    UploadSurveyInputColor: '#F5F6FA',
    UploadSurveyOptionsBorderColor: '#F5F6FA',
    UploadSurveyBackgroundActiveItem: '#F5F6FA',
    modalTitleColor: '#610082',
    modalBackgroundColor: '#fff',
    modalInputSearchBackgroundColor: '#F5F6FA',
    modalTitleBorderColor: '#F5F6FA',
    ModalTabActiveColor: '#610082',
    ModalTabInativeColor: '#6C6C6C',
    ModalTabInativeBottomColor: '#E0E0E0',
    ArrowIconCheckColor: '#00BEC1',
    ArrowIconUncheckColor: '#610082',
    ItemCheckedColor: '#610082',
    buttonHoverBackgroundColor: '#f7f7f7',
    numbersMenuTextColor: '#610082',
    numbersMenuBackgroundColor: '#FFFFFF',
    radioButtonColor: '#610082',
    normalButtonHoverBackgroundColor: '#500070',
    normalButtonBackgroundColor: '#00BEC1',
    normalConsolidationButtonBackgroundColor: '#610082',
    normalConsolidateButtonBackgroundColor: '#610082',
    normalConsolidationTextLabelColor: '#610082',
    normalConsolidationIconColor: '#00BEC1',
    normalButtonTextColor: '#ffffff',
    normalButtonHoverTextColor: '#ffffff',
    clearButtonHoverBackgroundColor: '#e7e7e7',
    clearButtonBackgroundColor: 'transparent',
    clearButtonTextColor: '#610082',
    clearButtonHoverTextColor: '#610082',
    promptBackgroundColor: 'rgba(0, 0, 0, 0.4)',
    promptPanelBackgroundColor: '#FFFFFF',
    promptTextColor: '#610082',
    promptOkButtonColor: '#00C6C9',
    surveysManagerTextColor: '#610082',
    surveysManagerRightBorderColor: '#E6E6E7',
    editorModalTextColor: '#610082',
    activeMenuBackgroundColor: '#FFFFFF',
    searchIconColor: '#00C6C9',
    headerGroupInputsBackgroundColor: '#F5F6FA',
    headerGroupInputsColorWhenSelected: '#6C6C6C',
    borderErrorColor: 'red',
    errorMessageTextColor: 'red',
    configSelectorDarkInputTextColor: '#FFFFFF',
    backgroundColorHeader: '#610082',
    headerName: '#FFF',
    iconButtonColor: '#610082',
    surveysManagerTableBorderColor: '#F5F6FA',
    surveysManagerIconColor: '#610082',
    menuItem: '#FFFFFF;',
    menuItemTextColor: '#610082',
    selectorTitle: '#610082',
    selectorBodyCloser: '#610082',
    backgroundColorPageInput: '#FFF',
    colorPageInputLabel: '#C4C4C4',
    nextPageInputBorder: '#610082',
    highlightFocusItem: 'linear-gradient(180deg, #F5F6FA 0%, #D9D9D9 100%);',
    disabledMenuItem: '#A1B4C4',
    disabledMeatballItem: '#A1B4C4',
    warningMessage: '#CA8B41',
    tooltipBackgroundColor: '#FFF',
    newTooltipBackgroundColor: '#D9D9D9',
    newTooltipTextColor: '#000',
    tooltipTextColor: '#610082',
    tooltipBorderColor: '#610082',
    menuIconTextColor: '#610082',
    menuMobileIconTextColor: '#FFFFFF',
    editSurveyBackgroundColor: '#F5F6FA',
    dateFilterBackgroundColor: '#A1B4C4',
  },
  simpleCross: {
    tableHeadBackgroud: '#00c6c9',
    tableHeadColor: '#fff',
    crossQuestionColor: '#610082',
    crossQuestionBackground: '#f4f4f4',
    borderColor: 'rgba(100, 100, 100, 0.1)',
    borderBottomColor: 'rgba(255, 255, 255, 0.1)',
    resultCelBackground: '#fff',
    gradeTitleBackground: '#035354',
    resultCelColor: '#6c6c6c',
    footerResultCelFontWeight: 'bold',
    footerTotalCelFontWeight: 'bold',
  },
  collapsibleList: {
    itemHoverBackground: '#eaeaea',
    textColor: 'inherit',
    titleColorBolded: '#610082',
    titleColorUnBolded: '#610082',
    circleBorder: '#610082',
  },
  collapsibleOrderableList: {
    itemHoverBackground: '#eaeaea',
    itemHoverColor: '#A1B4C4',
    textTitle: '#610082',
  },
  evolutiveConfig: {
    labelColor: '#610082',
  },
  simpleCrossConfig: {
    labelTextColor: '#610082',
  },
  cardSettings: {
    color: 'inherit',
  },
  card: {
    titleComplementHoverBackgroud: '#f4f4f4',
    listItemsTextColor: '#6C6C6C',
  },
  uploadSurvey: {
    uploadTipColor: '#610082',
  },
  simulation: {
    sliderThumbBorderColor: '#00BEC1',
    sliderThumbBackgroundColor: '#A1B4C4',
    sliderActiveBackgroundColor: '#00BEC1',
    sliderGroupBackgroundColor: '#fff',
    sliderGroupBorder: '#610082',
    infoBackgroundColor: '#610082',
    staticTextColor: '#A1B4C4',
    dynamicTextColor: '#6C6C6C',
    iconColor: '#610082',
    labelTextColor: '#18191B',
    boxShadow: '0px 2.88394px 2.88394px rgba(0, 0, 0, 0.25)',
  },
  cardAnnotationsMenu: {
    textColor: '#610082',
    iconColor: '#610082',
    iconDownColor: '#610082 ',
  },
  cardAnnotations: {
    iconColor: '#610082',
  },
  cardExporting: {
    iconColor: '#610082',
  },
  richTextToolbar: {
    iconColor: '#A1B4C4',
  },
  richTextBox: {
    editor: {
      background: '#F5F6FA',
      color: '#6C6C6C',
      placeHolder: '#6C6C6C',
    },
  },
  surveyManagement: {
    bodyIcon: {
      color: '#A1B4C4',
    },
  },
};
